<template>
  <li v-show="visible">
    <span :class="[prefixSelfClass + '-title']">{{ label }}</span>
    <ul ref="options">
      <slot></slot>
    </ul>
  </li>
</template>
<script>
  import { PREFIX_CLASS } from '../../utils/constants'

  const PREFIX_SELECT_GROUP_CLASS = `${PREFIX_CLASS}select__group`

  export default {
    name: 'TOptionGroup',
    props: {
      label: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        prefixSelfClass: PREFIX_SELECT_GROUP_CLASS,
        visibledItemCount: 0
      }
    },
    computed: {
      visible () {
        return (this.visibledItemCount > 0)
      }
    },
    created () {
      this.$on('item-mounted', (item) => {
        this.visibledItemCount++
        this.$parent.$emit('item-mounted', item)
      })
      this.$on('item-visible', (item) => {
        this.visibledItemCount++
      })
      this.$on('item-hidden', (item) => {
        this.visibledItemCount--
      })
    }
  }
</script>



// WEBPACK FOOTER //
// option-group.vue?02725933